// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// css
import '../../styles/components/sources/ImportSourcesModalUploaderItem.scss';


class ImportSourcesModalUploaderItem extends Component {

  getStatusClassNames() {
    const { result } = this.props;

    return classnames([
      'import-sources-modal-uploader-item__status',
      `import-sources-modal-uploader-item__status--${result.status}`
    ]);
  }

  renderStatus() {
    const { result } = this.props;

    return (
      <div className={this.getStatusClassNames()}>
        {result.status === 'success' ? 'Imported' : 'Import failed'}
      </div>
    );
  }

  renderRemoveLink() {
    const { onRemove } = this.props;

    return (
      <a onClick={onRemove} className='import-sources-modal-uploader-item__remove-link'>Remove</a>
    );
  }

  renderErrors() {
    const { result } = this.props;

    return (
      <div className='import-sources-modal-uploader-item__errors'>
        {result.errors.map((error, index) => (
          <div key={index} className='import-sources-modal-uploader-item__error'>
            {error.row &&
              <span>Error on row {error.row}: </span>
            }
            {error.field &&
              <span>{error.field}</span>
            }
            {error.field && error.message &&
              <span>&nbsp;</span>
            }
            <span>{error.message}</span>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { file, result } = this.props;

    return (
      <div className='import-sources-modal-uploader-item'>
        <div className='import-sources-modal-uploader-item__name'>
          {file.name}
        </div>
        {result && result.status !== 'pending' &&
          this.renderStatus()
        }
        {!result &&
          this.renderRemoveLink()
        }
        {result && result.status === 'failure' &&
          this.renderErrors()
        }
      </div>
    );
  }
}

ImportSourcesModalUploaderItem.propTypes = {
  onRemove: PropTypes.func.isRequired,
  file: PropTypes.object.isRequired,
  result: PropTypes.object
};

export default ImportSourcesModalUploaderItem;



// WEBPACK FOOTER //
// ./src/components/sources/ImportSourcesModalUploaderItem.js